/* eslint-disable @typescript-eslint/no-explicit-any */

import { isObject, toPath } from 'lodash/fp';

type NestedObject = Record<string, any>;

export function set(path: string, value: any, obj: NestedObject): void {
    const keys = obj.hasOwnProperty(path) ? [path] : toPath(path);

    if (keys.length === 0) {
        return;
    }

    let nested: NestedObject = obj;

    while (keys.length - 1) {
        const key = keys.shift() as string;
        if (!isObject(nested[key])) {
            nested[key] = {};
        }
        nested = nested[key];
    }

    nested[keys[0] as string] = value;
}
